import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { apiBaseUrl, apiVersion } from 'src/config';
import { Observable } from 'rxjs';

@Injectable()
export class FilterApi {
  private readonly http = inject(HttpClient);

  getAllMachineSerial$(): Observable<string[]> {
    return this.http.get<string[]>(`${apiBaseUrl}/search/listMachineSerial`);
  }

  getInitialRotorTypes$(): Observable<string[]> {
    return this.http.get<string[]>(`${apiBaseUrl}/search/listRotorType`);
  }

  searchForRotorTypes$(filterValue: string): Observable<string[]> {
    const entity = 'typeName';
    return this.http.get<string[]>(
      `${apiBaseUrl}/search/${entity}?api-version=${apiVersion}&search=${filterValue}`
    );
  }
}
